/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Documents/Navigation/Actions/CreateVirtualFile/Content/Name",
  onChange,
  isInvalid
  
}) {
let virtualFileNameValueData = fromData.useDataValue({ viewPath,
context: 'virtual_file',
path: 'name',
})
let virtualFileNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'virtual_file',
path: 'name',
validate: fromValidate.textInput,
required: true,
})
let virtualFileNameChangeData = fromData.useDataChange({ viewPath,
context: 'virtual_file',
path: 'name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 autoFocus={true}
 width="100%"
 marginTop={0}
 data="virtual_file.name"
 value={virtualFileNameValueData}
 onChange={virtualFileNameChangeData}
 required={true}
 validate="/Data/validate.js textInput"
 placeholder="Enter name"
 invalid={!virtualFileNameIsValidData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}